// The repo fingerprint (data-model.md "fingerprints"; D63; ADR-0016 §3).
//
// Detection runs only once a repo exists (workflows.md:9), never before an app is added. The deep
// jsonb profiles (stack, dependencies, build_target) drive runner-class dispatch (D63). The Slice-2
// FIXTURE detector derives only {hasPayments,hasAuth,hasPii} from the founder's declared answers, so
// the jsonb profiles are nullable until Slice 3's real detector (behind `connections.real_fingerprint`).
import { z } from "zod";
import { AppId, FingerprintId } from "../ids.js";
import { JsonObject, Timestamp } from "./common.js";
/**
 * The subset the route recommendation consumes: the three floor flags that force a required
 * environment (payments/auth/PII), plus the raw stack and build-target profiles. `stack` and
 * `buildTarget` are null when the fixture detector has not populated them.
 */
export const FingerprintSummary = z.object({
    hasPayments: z.boolean(),
    hasAuth: z.boolean(),
    hasPii: z.boolean(),
    stack: JsonObject.nullable(),
    buildTarget: JsonObject.nullable(),
});
/** A stored fingerprint row (data-model.md fingerprints). The jsonb profiles are nullable pre-detection. */
export const Fingerprint = z.object({
    id: FingerprintId,
    appId: AppId,
    /** jsonb: frontend, backend, db (data-model.md). */
    stack: JsonObject.nullable(),
    /** jsonb: the dependency set. */
    dependencies: JsonObject.nullable(),
    hasPayments: z.boolean(),
    hasAuth: z.boolean(),
    hasPii: z.boolean(),
    /** jsonb: platforms, toolchain, runner_classes, signing_reqs, distribution, ... (D63). */
    buildTarget: JsonObject.nullable(),
    detectedAt: Timestamp,
});
//# sourceMappingURL=fingerprint.js.map